var gridPrefix = "Grid";
var filterOperatorReadableReplacements = {
    contains: "contains",
    startswith: "starts with",
    endswith: "ends with",
    eq: "is",
    doesnotcontain: "does not contain",
    neq: "is not equal to",
    isempty: "is empty",
    isnotempty: "is not empty",
    gt: "is greater than",
    lt: "is less than",
    gte: "is greater than or equal to",
    lte: "is less than or equal to"
};
var showInactive = false;

var deleteKendoUiWindowOptions = {
    title: "Confirm Deletion",
    visible: false,
    minWidth: "300px",
    maxWidth: "450px",
    minHeight: "120px",
    modal: true,
    pinned: true,
    draggable: false,
    resizable: false,
    actions: []
};

var restoreKendoUiWindowOptions = {
    title: "Confirm Restore",
    visible: false,
    minWidth: "300px",
    maxWidth: "450px",
    minHeight: "120px",
    modal: true,
    pinned: true,
    draggable: false,
    resizable: false,
    actions: []
};
var deleteConfirmedKendoUiWindowOptions = {
    title: false,
    visible: false,
    minWidth: "300px",
    maxWidth: "450px",
    minHeight: "120px",
    modal: false,
    pinned: true,
    draggable: false,
    autoFocus: true,
    resizable: false,
    actions: []
};

function saveGridOptionsToSessionStorage(entityType, options) {
    sessionStorage.setItem(gridPrefix + entityType, options);
}

function loadGridOptionsFromSessionStorage(entityType) {
    return sessionStorage.getItem(gridPrefix + entityType);
}

function clearAllGridOptions() {
    removeSessionStorageItemsByPrefix(gridPrefix);
}

function clearAllOtherGridOptions(gridToPreserve) {
    removeSessionStorageItemsByPrefix(gridPrefix, gridPrefix + gridToPreserve);
}

function removeSessionStorageItemsByPrefix(prefix, keyToPreserve) {
    var arr = []; // Array to hold the keys
    // Iterate over localStorage and insert the keys that meet the condition into arr
    for (var i = 0; i < sessionStorage.length; i++) {
        if (keyToPreserve) {
            if (sessionStorage.key(i).substring(0, 4) === prefix && !sessionStorage.key(i).startsWith(keyToPreserve)) {
                arr.push(sessionStorage.key(i));
            }
        } else {
            if (sessionStorage.key(i).substring(0, 4) === prefix) {
                arr.push(sessionStorage.key(i));
            }
        }

    }

    // Iterate over arr and remove the items by key
    for (var l = 0; l < arr.length; l++) {
        sessionStorage.removeItem(arr[l]);
    }
}

function applyExcelExportEventAnimation() {
    $(".k-grid-excel").off("click");
    $(".k-grid-excel")
        .click(function() {
            $(this).attr("data-loading-text", "<i class='fa fa-circle-o-notch fa-spin'></i> Exporting...");
            $(this).button("loading");
        });
}

function excelExport(e) {
    var gridName = e.sender.element[0].id;
    if (!window["exportFlag" + gridName]) {
        e.preventDefault();
        window["exportFlag" + gridName] = true;
        var newGrid = $("#placeholderGrid").kendoGrid(e.sender.getOptions()).data("kendoGrid");
        setTimeout(
            function() {
                newGrid.columns.forEach(function(column) {
                    column.hidden = false;
                });
                newGrid.saveAsExcel();

            },
            800);
    } else {
        window["exportFlag" + gridName] = false;
        var $exportBtns = $(".k-grid-excel");
        $exportBtns.button("reset");
    }
}

function splitStringArrayIntoCommaSeparatedWithAnd(array) {
    return [array.slice(0, -1).join(", "), array.slice(-1)[0]].join(array.length < 2 ? "" : ", and ");
}

function setFilterText(grid) {
    var filterTexts = [];
    var gridFilter = grid.dataSource.filter();
    if (gridFilter !== null && gridFilter !== undefined) {
        var currentFilters = gridFilter.filters;
        if (currentFilters.length > 0) {
            for (var filterIndex in currentFilters) {
                var filterText = "";
                var propertyText = "";
                var filter = currentFilters[filterIndex];
                if (filter.field) {

                    filterText += filter.field +
                        " " +
                        filterOperatorReadableReplacements[filter.operator] +
                        (filter.value !== null && filter.value !== undefined && filter.value !== ""
                            ? ' "' + filter.value + '"'
                            : "");
                    propertyText = filter.field;
                } else {
                    var compositeOperator = filter.logic;
                    var compositeFilters = filter.filters;
                    var compositeFilterText = "";
                    if (compositeFilters.length > 0) {
                        for (var compositeFilterIndex in compositeFilters) {
                            var compositeFilter = compositeFilters[compositeFilterIndex];


                            if (compositeFilter.field && compositeFilter.field !== "Active") {
                                if (compositeFilterIndex === "0") {
                                    compositeFilterText += compositeFilter.field + " ";
                                }
                                compositeFilterText += filterOperatorReadableReplacements[compositeFilter.operator] +
                                (compositeFilter.value !== null &&
                                    compositeFilter.value !== undefined &&
                                    compositeFilter.value !== ""
                                    ? ' "' + compositeFilter.value + '"'
                                    : "");

                                propertyText = compositeFilter.field;
                            }

                            if (compositeFilterIndex !== (compositeFilters.length - 1).toString()) {
                                compositeFilterText += " " + compositeOperator + " ";
                            }
                        }

                        filterText += compositeFilterText;
                    }

                }

                if (propertyText !== "Active")
                    filterTexts.push({ Property: propertyText, FilterText: filterText });

            }

            var sortedFilters = filterTexts.sort(function(a, b) {
                var textA = a.Property.toUpperCase();
                var textB = b.Property.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });

            var sortedFilterTexts = [];
            $.each(sortedFilters,
                function(i, o) {
                    sortedFilterTexts[i] = o.FilterText;
                });

            var $toolbar = $(grid.element[0]).find(".k-header.k-grid-toolbar");
            var $clearFilterButton = $toolbar.children(".gridAllFilterReset");
            var $filterText = $toolbar.children(".k-text");
            var $activeToggleButton = $(".k-button-toggleActive");

            if ($clearFilterButton.length === 0) {
                if (sortedFilterTexts.length > 0) {
                    $toolbar
                        .prepend(
                            '<a class="k-button left k-button-icontext k-grid-ClearFilters gridAllFilterReset" href="#"><span class="glyphicon glyphicon-remove"></span>Clear Filters</a>');
                }

            } else {
                if (sortedFilterTexts.length === 0) {
                    $clearFilterButton.remove();
                }
            }

            if ($filterText.length > 0) {
                if (sortedFilterTexts.length > 0) {
                    $filterText.html("Where " + splitStringArrayIntoCommaSeparatedWithAnd(sortedFilterTexts));
                } else {
                    $filterText.remove();
                }
            } else {
                if (sortedFilterTexts.length > 0) {
                    if ($activeToggleButton.length === 0) {
                        $toolbar.prepend('<span class="k-text" style="max-width: 60%;"> Where ' +
                            splitStringArrayIntoCommaSeparatedWithAnd(sortedFilterTexts) +
                            "</span>");
                    } else {
                        $toolbar.prepend('<span class="k-text"> Where ' +
                            splitStringArrayIntoCommaSeparatedWithAnd(sortedFilterTexts) +
                            "</span>");
                    }

                    applyClearFilterClickEvent(grid);
                }
            }

        }
    }
}

function applyClearFilterClickEvent(grid) {
    $(".gridAllFilterReset").off("click");

    var $gridButton = $(grid.element[0]).find(".gridAllFilterReset");
    if ($gridButton.length > 0) {
        $gridButton.click(function(e) {
            e.preventDefault();
            var activeFilter = grid.dataSource.filter().filters.find(getActiveFilter);
            if (activeFilter) {
                grid.dataSource.filter(activeFilter);
            } else {
                grid.dataSource.filter(null);
            }

            clearAllGridOptions();
        });
    }
}

function getActiveFilter(element) {
    return element.field === "Active";
}

function applyGridDataBound(controllerName, e) {

    var grid = e.sender;
    var gridName = grid.element[0].id;
    console.log("Grid name for data bound: " + gridName);
    var $toolbar = $(grid.element[0]).find(".k-header.k-grid-toolbar");
    setFilterText(grid);
    console.log("toggle bar:");
    console.log($toolbar);

    e.sender.thead
        .find("th.k-header")
        .each(function () {
            $(this).attr("title", $(this).text());
        });

    //remove filters text and clear filters button if there are none
    if (grid.dataSource.filter() === null || grid.dataSource.filter() === undefined) {
        $toolbar.children(".gridAllFilterReset").remove();
        $toolbar.children(".k-text").remove();
    }

    //add the inactive/active button
    var $activeToggleButton = $(grid.element[0]).find(".k-button-toggleActive");
    if ($activeToggleButton.length === 0) {
        console.log("appending show button for grid " + gridName);
        $toolbar
            .append(
                '<a class="k-button k-button-icontext k-button-toggleActive" href="#"><span class="glyphicon glyphicon-eye-' +
                (showInactive === true ? "open" : "close") +
                '"></span>Show ' +
                (showInactive === true ? "Active" : "Deleted") +
                "</a>");
        $(".k-button-toggleActive")
            .click(function(event) {
                event.preventDefault();
                toggleGridActiveState(grid, $toolbar);
            });
    }

    setGridToInactiveDisplay(grid, $toolbar, showInactive);
    console.log("grid bound!");
}

function applyGridDataBindings(controllerName, e) {
    var grid = e.sender;
    var gridName = grid.element[0].id;
    var stringifiedOptions = loadGridOptionsFromSessionStorage(controllerName + gridName);
    var applyingFilters = window["applyingFilters" + controllerName + gridName];
    kendo.ui.progress(grid.element, true);

    if (stringifiedOptions && applyingFilters === false) {
        e.preventDefault();
        clearAllOtherGridOptions(controllerName);
        setFilterText(grid);

        window.setTimeout(
            function() {
                var loadedOptions = JSON.parse(stringifiedOptions);
                var originalOptions = grid.getOptions();

                loadedOptions.columns = originalOptions.columns;
                grid.setOptions(loadedOptions);

            },
            750);

        window["applyingFilters" + controllerName + gridName] = true;
    } else {
        applyExcelExportEventAnimation(grid);
        window["applyingFilters" + controllerName + gridName] = true;
    }
    kendo.ui.progress(grid.element, false);
}

function toggleGridActiveState(grid, $toolbar) {

    var filters;

    if (showInactive === true) {
        showInactive = false;
        var activeFilter = grid.dataSource.filter().filters.find(getActiveFilter);
        filters = jQuery.grep(grid.dataSource.filter().filters,
            function(value) {
                return value !== activeFilter;
            });
        if (filters.length === 0) {
            grid.dataSource.filter(null);
        }

        if (filters.length > 0) {
            grid.dataSource.filter(filters);
        }
    } else {
        showInactive = true;
        var filterToAdd = { field: "Active", operator: "eq", value: false };

        if (grid.dataSource.filter() === undefined || grid.dataSource.filter() === null) {
            grid.dataSource.filter(filterToAdd);
        } else {
            filters = grid.dataSource.filter().filters;
            filters.push(filterToAdd);
            grid.dataSource.filter(filters);
        }
    }

    grid.dataSource.sync();
}

function setGridToInactiveDisplay(grid, $toolbar, showingInactive) {
    if (showingInactive) {
        $toolbar.addClass("red");
        $(".k-button-toggleActive").html('<span class="glyphicon glyphicon-eye-open"></span>Show Active');
        $(".k-button.k-button-icontext.k-grid-Restore").toggle(true);
        $(".k-button.k-button-icontext.k-grid-Delete").toggle(false);
        $(".k-button.k-button-icontext.k-grid-Leave").toggle(false)

    } else {
        $toolbar.removeClass("red");
        $(".k-button-toggleActive").html('<span class="glyphicon glyphicon-eye-close"></span>Show Inactive');
        $(".k-button.k-button-icontext.k-grid-Restore").toggle(false);
        $(".k-button.k-button-icontext.k-grid-Delete").toggle(true);
        $(".k-button.k-button-icontext.k-grid-Leave").toggle(true)
    }
}

function deleteGridItem(e, controller) {
    e.preventDefault(); //prevent page scroll reset
    var controllerName = controller;
    var gridName = $(e.delegateTarget).data("kendoGrid").element[0].id;
    var tr = $(e.target).closest("tr"); //get the row for deletion
    tr.addClass("deletingGridItem");
    var data = $(e.delegateTarget).data("kendoGrid").dataItem(tr); //get the row data so it can be referred later
    window["$" + controllerName + gridName + "DeleteWindow"]
        .content(window[controllerName + gridName + "DeleteTemplate"](data));
//send the row data object to the template and render it
    window["$" + controllerName + gridName + "DeleteWindow"].center().open();
    console.log("deleting grid item");
    $("#yesDeleteButton")
        .click(function() {
            var datasource = $(e.delegateTarget).data("kendoGrid").dataSource;
            datasource.remove(data); //prepare a "destroy" request
            datasource.sync(); //actually send the request (might be ommited if the autoSync option is enabled in the dataSource)
            $(".k-loading-mask").hide();
            window["$" + controllerName + gridName + "DeleteWindow"].close();
            window["$" + controllerName + gridName + "DeleteConfirmedWindow"].content(window[controllerName + gridName + "DeleteConfirmedTemplate"](data));
            window["$" + controllerName + gridName + "DeleteConfirmedWindow"].center().open();

            $("#actionConfirmedWindow")
                .click(function() {
                    window["$" + controllerName + gridName + "DeleteConfirmedWindow"].close();
                });

            window.setTimeout(function() {
                    window["$" + controllerName + gridName + "DeleteConfirmedWindow"].close();
                },
                1000);
        });
    $("#noDeleteButton")
        .click(function() {
            tr.removeClass("deletingGridItem");
            window["$" + controllerName + gridName + "DeleteWindow"].close();
        });
}

function restoreGridItem(e, controller) {
    console.log("restoring item");
    e.preventDefault(); //prevent page scroll reset
    var controllerName = controller;
    var gridName = $(e.delegateTarget).data("kendoGrid").element[0].id;
    var tr = $(e.target).closest("tr"); //get the row for deletion
    tr.addClass("restoringGridItem");
    var data = $(e.delegateTarget).data("kendoGrid").dataItem(tr); //get the row data so it can be referred later
    window["$" + controllerName + gridName + "RestoreWindow"]
        .content(window[controllerName + gridName + "RestoreTemplate"](data));
    //send the row data object to the template and render it
    window["$" + controllerName + gridName + "RestoreWindow"].center().open();

    $("#yesRestoreButton").click(function() {
        console.log("yes clicked");
        $(window["$" + controllerName + gridName + "RestoreWindow"].element).find("#yesButton");
        window["restore" + controllerName + gridName] = true;
        var datasource = $(e.delegateTarget).data("kendoGrid").dataSource;
        datasource.remove(data); //prepare a "destroy" request
        datasource.sync();
        //actually send the request (might be ommited if the autoSync option is enabled in the dataSource)
        window["$" + controllerName + gridName + "RestoreWindow"].close();
        window["$" + controllerName + gridName + "RestoreConfirmedWindow"]
            .content(window[controllerName + gridName + "RestoreConfirmedTemplate"](data));
        window["$" + controllerName + gridName + "RestoreConfirmedWindow"].center().open();

        $("#actionConfirmedWindow")
            .click(function() {
                window["$" + controllerName + gridName + "RestoreConfirmedWindow"].close();
            });

        window.setTimeout(function() {
                window["$" + controllerName + gridName + "RestoreConfirmedWindow"].close();
            },
            1500);
    });
    $("#noRestoreButton")
        .click(function() {
            tr.removeClass("restoringGridItem");
            window["$" + controllerName + gridName + "RestoreWindow"].close();
        });
}

function stopScroll(element) {
    var activeElement;

    $(document)
        .bind("mousewheel DOMMouseScroll",
            function(e) {
                var scrollTo = null;

                if (!$(activeElement).closest(".k-popup").length) {
                    return;
                }

                if (e.type == "mousewheel") {
                    scrollTo = (e.originalEvent.wheelDelta * -1);
                } else if (e.type == "DOMMouseScroll") {
                    scrollTo = 40 * e.originalEvent.detail;
                }

                if (scrollTo) {
                    e.preventDefault();
                    element.scrollTop(scrollTo + element.scrollTop());
                }
            });

    $(document)
        .on("mouseover",
            function(e) {
                activeElement = e.target;
            });
}

function confirmationWindow(text, successText, yesButtonText, noButtonText, windowTitle, callback) {
    var windowData = {
        text: "Are you sure you want to delete this item?",
        successText: "Item successfully deleted.",
        yesButtonText: "Yes",
        noButtonText: "No",
    }
    if (text) { windowData.text = text; }
    if (successText) { windowData.successText = successText; }
    if (yesButtonText) { windowData.yesButtonText = yesButtonText; }
    if (noButtonText) { windowData.noButtonText = noButtonText; }


    var genericConfirmTemplate = kendo.template($('#generic-confirm-template').html());
    var genericConfirmConfirmedTemplate = kendo.template($('#generic-confirm-confirmed-template').html());

    $('body').append('<div id="genericConfirmWindow"></div>');
    $('body').append('<div id="genericConfirmConfirmedWindow" class="actionConfirmedWindow"></div>');

    if (windowTitle) {
        deleteKendoUiWindowOptions.title = windowTitle;
    } else {
         deleteKendoUiWindowOptions.title = "Confirm Action";
    }

    var $genericConfirmWindow = $('#genericConfirmWindow').kendoWindow(deleteKendoUiWindowOptions).data('kendoWindow');
    var $genericConfirmConfirmedWindow = $('#genericConfirmConfirmedWindow').kendoWindow(deleteConfirmedKendoUiWindowOptions).data('kendoWindow');

    $genericConfirmWindow.content(genericConfirmTemplate(windowData));
    $genericConfirmWindow.center().open(); genericConfirmConfirmedTemplate

    $("#genericConfirmWindow #confirmYesButton")
        .click(function () {
            callback();
            $genericConfirmWindow.close();
            $genericConfirmConfirmedWindow.content(genericConfirmConfirmedTemplate(windowData));
            $genericConfirmConfirmedWindow.center().open();

            $("#actionConfirmedWindow")
                .click(function () {
                    $genericConfirmConfirmedWindow.close();
                });

            window.setTimeout(function () {
                    $genericConfirmConfirmedWindow.close();
                },
                1200);
        });
    $("#genericConfirmWindow #confirmNoButton")
        .click(function () {
            $genericConfirmWindow.close();
        });

    $('body').remove('#genericConfirmWindow');
    $('body').remove('#genericConfirmConfirmedWindow.actionConfirmedWindow');
}

function removeItemFromTreeViewDataSource(pageModelPropertyWithItems, textOfItemToRemove) {
    var array = pageModelPropertyWithItems();
    removeItemFromTreeViewRecursively(array, textOfItemToRemove);
    pageModelPropertyWithItems(array);
}

function removeItemFromTreeViewRecursively(array, textOfItemToRemove) {
    var index = 0;
    if (array && array.length > 0) {
        var matchedItem = $.grep(array, function (item) {
            return item.text === textOfItemToRemove;
        });

        if (matchedItem && matchedItem.length > 0) {
            index = array.indexOf(matchedItem[0]);
            if (index > -1) {
                array.splice(index, 1);
            }
        } else {
            for (var i = 0; i < array.length; i++) {
                var item = array[i];
                removeItemFromTreeViewRecursively(item.items, textOfItemToRemove);
            }
        }
    }
}

//this method should be called inside the logic where a new item gets added to a grid
//the id should be the value of the unique identifer stored in the hidden column in the grid that was just added to the grid
//can be empty to just refresh the yellow highlights, like when removing an item
//grid is the selector of a kendo grid, must have a valid kendo grid associated with it
//the cssClassSuffixForIdColumn is the suffix of the class name, the id column on the grid should have
//its class set to that same suffix plus the id properity
//ex: { field: "[IdName]", hidden: true, attributes: { "class": "#= data.[IdName] #-id-column" } }
function setNewlyAddedOnGrid(id, gridSelector, cssClassSuffixForIdColumn) {
    var grid = $(gridSelector).data("kendoGrid");
    var keyName = gridSelector.replace(".", "").replace("#", "").replace("Grid", "")

    if (grid != null) {
        if (window[keyName + "NewlyAdded"] == undefined) {
            window[keyName + "NewlyAdded"] = [];
        }

        if (window[keyName + "NewlyAdded"].indexOf(id) == -1 && id != undefined && id != null && id != "") {
            window[keyName + "NewlyAdded"].push(id);
        }

        for (var i = 0; i < window[keyName + "NewlyAdded"].length; i++) {
            var id = window[keyName + "NewlyAdded"][i]
            grid.element.find("td." + id + cssClassSuffixForIdColumn).parent("tr").addClass("just-added");
        }
    } else {
        console.log("Error: No kendo grid attached to selector '" + gridSelector + "'");
    }

    
}
